module.exports = __webpack_public_path__ + "static/media/Hombre2.95cf9a17.svg";